import React from "react";
import { useSelector } from "react-redux";
import {
    selectAllProductModal,
    setProductModalOpen,
} from "../../../../redux/slices/productModalSlice";
import ProductModalContent from "./ProductModalContent";

const ConnectedProductModalContent = () => {
    const { productModalOpen, currentProductId } = useSelector(
        selectAllProductModal,
    );

    // This prevents the background app from scrolling when modal is open
    if (productModalOpen) {
        document.getElementById("app").classList.add("no-scroll");
    } else {
        document.getElementById("app").classList.remove("no-scroll");
    }

    const productModalContentProps = {
        currentProductId,
        productModalOpen,
        setProductModalOpen,
    };
    return <ProductModalContent {...productModalContentProps} />;
};

export default ConnectedProductModalContent;
